import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let links = document.querySelectorAll('[paws-component="noss-nav"][paws-template="mobile"] .nav-link');
    let offCanvas = document.querySelector('[paws-component="noss-nav"][paws-template="mobile"].offcanvas');
    let offCanvasObject = new window.bootstrap.Offcanvas(offCanvas);

    for (let i = 0; i < links.length; ++i) {
        if (links[i].href.indexOf('#') > -1) {
            // deeplink
            links[i].addEventListener('click', function (event) {
                offCanvasObject.hide();
                document.getElementById(links[i].href.split('#')[1]).focus();
            });
        }
    }
}